module.exports = __webpack_public_path__ + "img/0Q3A5061_P_L_BlackMatted_MockedUp.13f1b400.jpg";